import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useMemo } from "react";

function ChevronLeftIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const svgValue = useMemo(() => {
    if (fontSize === "small") {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.33331 4L5.33331 8L9.33331 12"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (fontSize === "large") {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.6667 8L10.6667 16L18.6667 24"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    return (
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 6L8 12L14 18"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }, [fontSize]);

  return <SvgIcon {...props}>{svgValue}</SvgIcon>;
}
export default ChevronLeftIcon;
